<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'"
       [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.notification' : 'misc.edition.notification') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="notificationForm" *ngIf="notificationForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="notificationForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-12 xl:col-3">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="tenantChanged()"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            [showClear]="true"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            formControlName="organization"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="topic">{{'attribute.topic' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="topic" type="text" formControlName="topic" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="notificationType">{{'attribute.notificationType' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.notificationType' | transloco"
            [options]="notificationTypes | translateLabels:'name' | async"
            styleClass="w-full"
            id="notificationType"
            optionLabel="name"
            formControlName="notificationType"
            dataKey="delay"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="subject">{{'attribute.subject' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="subject" type="text" formControlName="subject" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-6">
        <div class="form-field col-12">
          <label for="subject">{{'attribute.emails' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-chips (onAdd)="validateEmail($event)" (onRemove)="addUnsubcribedEmails($event)" formControlName="emails"
                   [allowDuplicate]="false" class="p-fluid" id="emails" separator=","></p-chips>
        </div>
      </div>


      <div class="col-12">
        <div class="grid">

          <div class="col-6">
            <div class="form-field">
              <div class="form-field col-12">
                <label for="template">{{'attribute.inputTemplate' | transloco}} (*)</label>
                <i
                  (click)="appliedToInfoVisible = !appliedToInfoVisible"
                  class="pi pi-info-circle cursor-pointer ml-2"
                  style="font-size: 14px;"
                ></i>
              </div>
              <div class="col-12">
                <div *ngIf="appliedToInfoVisible then appliedToInfo"></div>
                <angular-editor formControlName="template" id="template" [config]="editorService.editorConfig"
                                autoResize="autoResize" class="w-full">
                </angular-editor>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="form-field">
              <div class="form-field col-12">
                <label>{{'attribute.outputTemplate' | transloco}}</label>
              </div>
            </div>
            <div class="col-12">
              <div id="viewTemplate" style="border: 1px solid #D1D6DC; padding: 5px; border-radius: 3px; height: 100%"
                   [innerHtml]="notificationForm.get('template').value || '' | mustache | trustContent: 'html'">
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button pButton label="{{'common.cancel' | transloco}}" iconPos="right" class="p-button-danger"
              [routerLink]="'/notifications'"></button>
      <p-button
        *ngIf="notificationForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        [disabled]="!notificationForm.valid"
        (onClick)="persistNotificationData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>

<ng-template #appliedToInfo>
  <div class="border-1 border-round border-gray-300 mb-3 fadein animation-duration-200">
    <p class="px-3 pt-3 text-justify">{{'info.notifications.summary' | transloco}}</p>
    <p class="px-3 text-justify">{{'info.notifications.firstExample' | transloco}}</p>
    <pre class="bg-gray-50">
      <p-tree class="w-full md:w-30rem" [value]="nodesTemplateInfo"></p-tree>
    </pre>
    <p></p>
    <p class="px-3 text-justify">{{'info.notifications.secondExample' | transloco}}</p>
    <pre class="bg-gray-50"><code ngNonBindable>
      Número de serie: {{device.serialNumber}}
      Cliente: {{device.organization.tenant.name}}
      Organización:  {{device.organization.name}}
    </code></pre>
  </div>
</ng-template>
